import React from "react";
import loader from 'Assets/LottieLoader/loader.json';
import Lottie from "lottie-react";
import Translator from "Languages/Utility/Translator";

export default function BankTransactionLoading() {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center shadow-lg px-5" style={{'minHeight':'180px', 'borderRadius':'10px'}}>
            <Lottie animationData={loader} loop={true} style={{'width':'170px'}} />
            <strong className="mb-5" style={{'fontSize':'18px', 'color':'#009ee3'}}>
                <Translator id={'pleaseWait'} noSpan />
            </strong>
        </div>
    );
}
